const buildSelectOptions = options => {
  if (!options || !options.length) return [];
  const parsedOptions = options.map(({ id, name }) => {
    if (!id) return [name, name];
    return [id, name];
  });
  return parsedOptions;
};

export default buildSelectOptions;
